// extracted by mini-css-extract-plugin
export default {"loader_overlay":"Loader_loader_overlay__VG5gs","loader":"Loader_loader__DwtSp"};